<template>
    <div class="text-center my-2">
        <div class="spinner-border text-secondary m-1 align-middle " role="status">
            <span class="sr-only"></span>
        </div>
        <p class="text-muted mb-0" v-if="!isUploading">Chargement...</p>
        <p class="text-muted mt-3 mb-0" v-if="isUploading">Upload et traitement...</p>
        <div class="row justify-content-center mt-3" v-if="isUploading">
            <div class="col-md-6">
                <div class="progress bg-secondary-subtle animated-progress">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-secondary" role="progressbar" :aria-valuenow="percentage" aria-valuemin="0" aria-valuemax="100" :style="'width: '+percentage+'%;'"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

const props = defineProps({
    percentage: {
        type: Number,
        required: false,
        default: 0
    },
    isUploading: {
        type: Boolean,
        required: false,
        default: false
    }
})
</script>

<style></style>
